<template>
	<b-list-group flush class="d-flex flex-row flex-wrap">

		<div class="col-12 col-sm-6 pl-0 pr-0">
			<li class="list-group-item p-0 d-flex flex-row border">
				<div class="d-table-cell p-2 mr-auto">
					<p class="mb-0">
						<strong>STR</strong> <small class="text-muted">Strength</small>
					</p>
				</div>
				<div class="d-table-cell p-2 number">{{abilityScores['Strength']}}</div>
				<div class="d-table-cell p-2 number">{{abilityMods['Strength']}}</div>
				<div class="d-table-cell p-2 rollers">
					<dice-button :data-dice-notation="abilityMods['Strength'] | d20roll"></dice-button>
				</div>
			</li>
		</div>

		<div class="col-12 col-sm-6 pl-0 pr-0">
			<li class="list-group-item p-0 d-flex flex-row border">
				<div class="d-table-cell p-2 mr-auto">
					<p class="mb-0">
						<strong>DEX</strong> <small class="text-muted">Dexterity</small>
					</p>
				</div>
				<div class="d-table-cell p-2 number">{{abilityScores['Dexterity']}}</div>
				<div class="d-table-cell p-2 number">{{abilityMods['Dexterity']}}</div>
				<div class="d-table-cell p-2 rollers">
					<dice-button :data-dice-notation="abilityMods['Dexterity'] | d20roll"></dice-button>
				</div>
			</li>
		</div>
		
		<div class="col-12 col-sm-6 pl-0 pr-0">
			<li class="list-group-item p-0 d-flex flex-row border">
				<div class="d-table-cell p-2 mr-auto">
					<p class="mb-0">
						<strong>CON</strong> <small class="text-muted">Constitution</small>
					</p>
				</div>
				<div class="d-table-cell p-2 number">{{abilityScores['Constitution']}}</div>
				<div class="d-table-cell p-2 number">{{abilityMods['Constitution']}}</div>
				<div class="d-table-cell p-2 rollers">
					<dice-button :data-dice-notation="abilityMods['Constitution'] | d20roll"></dice-button>
				</div>
			</li>
		</div>
		
		<div class="col-12 col-sm-6 pl-0 pr-0">
			<li class="list-group-item p-0 d-flex flex-row border">
				<div class="d-table-cell p-2 mr-auto">
					<p class="mb-0">
						<strong>INT</strong> <small class="text-muted">Intelligence</small>
					</p>
				</div>
				<div class="d-table-cell p-2 number">{{abilityScores['Intelligence']}}</div>
				<div class="d-table-cell p-2 number">{{abilityMods['Intelligence']}}</div>
				<div class="d-table-cell p-2 rollers">
					<dice-button :data-dice-notation="abilityMods['Intelligence'] | d20roll"></dice-button>
				</div>
			</li>
		</div>
		
		<div class="col-12 col-sm-6 pl-0 pr-0">
			<li class="list-group-item p-0 d-flex flex-row border">
				<div class="d-table-cell p-2 mr-auto">
					<p class="mb-0">
						<strong>WIS</strong> <small class="text-muted">Wisdom</small>
					</p>
				</div>
				<div class="d-table-cell p-2 number">{{abilityScores['Wisdom']}}</div>
				<div class="d-table-cell p-2 number">{{abilityMods['Wisdom']}}</div>
				<div class="d-table-cell p-2 rollers">
					<dice-button :data-dice-notation="abilityMods['Wisdom'] | d20roll"></dice-button>
				</div>
			</li>
		</div>
		
		<div class="col-12 col-sm-6 pl-0 pr-0">
			<li class="list-group-item p-0 d-flex flex-row border">
				<div class="d-table-cell p-2 mr-auto">
					<p class="mb-0">
						<strong>CHA</strong> <small class="text-muted">Charisma</small>
					</p>
				</div>
				<div class="d-table-cell p-2 number">{{abilityScores['Charisma']}}</div>
				<div class="d-table-cell p-2 number">{{abilityMods['Charisma']}}</div> 
				<div class="d-table-cell p-2 rollers">
					<dice-button :data-dice-notation="abilityMods['Charisma'] | d20roll"></dice-button>
				</div>
			</li>
		</div>
	</b-list-group>	
</template>

<script>
import {mapGetters} from 'vuex'
import DiceButton from '@/components/DiceButton.vue'

export default {
	components: {
		'DiceButton': DiceButton,
	},
	computed: {
		...mapGetters( 'character/abilityScores',
		[
			'abilityScores',
			'abilityMods',
		])
	}
}
</script>

<style scoped>

</style>